module.exports = function getResource(label, vars = []) {
    let resources = {
        profile: 'Profil',
        beautInsider: 'Beauty Insider',
        creditCard: 'Carte de crédit',
        lists: 'Listes',
        account: 'Compte',
        profileSubnavigation: 'Navigation dans le profil'
    };

    return resources[label];
};
